import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { LOGO } from "./constants";

const LINKS = [
  { label: "Chi Siamo", href: "#chi-siamo" },
  { label: "Metodo", href: "#metodo" },
  { label: "Recensioni", href: "#recensioni" },
  { label: "Contatti", href: "#contatti" },
];

export const Navigation = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      data-testid="main-navigation"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 1.6, ease: [0.76, 0, 0.24, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,border-color,padding] duration-500 ${
        scrolled
          ? "bg-[#F5F6F2]/75 backdrop-blur-xl border-b border-[#2E3131]/10 py-4"
          : "bg-transparent border-b border-transparent py-6"
      }`}
    >
      <nav className="max-w-[1500px] mx-auto px-6 md:px-12 lg:px-16 flex items-center justify-between">
        <a href="#top" data-testid="logo-link" aria-label="Alba Immobili" className="block h-8 md:h-9 w-[100px] md:w-[116px] transition-transform duration-300 hover:opacity-80" style={{ backgroundColor: "#2E3131", WebkitMaskImage: `url(${LOGO})`, maskImage: `url(${LOGO})`, WebkitMaskRepeat: "no-repeat", maskRepeat: "no-repeat", WebkitMaskSize: "contain", maskSize: "contain", WebkitMaskPosition: "left center", maskPosition: "left center" }} />

        <div className="hidden md:flex items-center gap-10">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.href.replace("#", "")}`}
              className="text-sm text-[#2E3131]/70 hover:text-[#2E3131] transition-colors duration-300 relative group"
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 h-px w-0 bg-[#21463E] group-hover:w-full transition-[width] duration-300" />
            </a>
          ))}
          <a
            href="#contatti"
            data-testid="nav-cta-desktop"
            className="group inline-flex items-center gap-2 bg-[#2E3131] text-[#F5F6F2] rounded-full pl-5 pr-4 py-2.5 text-sm hover:bg-[#21463E] transition-colors duration-300"
          >
            Valuta la tua casa
            <span className="inline-block group-hover:translate-x-1 transition-transform duration-300">→</span>
          </a>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-[#2E3131]"
          onClick={() => setOpen((v) => !v)}
          aria-label="Menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </nav>

      <AnimatePresence>
        {open && (
          <motion.div
            data-testid="mobile-menu"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.4, ease: [0.76, 0, 0.24, 1] }}
            className="md:hidden overflow-hidden bg-[#F5F6F2]/95 backdrop-blur-xl border-t border-[#2E3131]/10"
          >
            <div className="px-6 py-6 flex flex-col gap-5">
              {LINKS.map((l) => (
                <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="text-lg text-[#2E3131]">
                  {l.label}
                </a>
              ))}
              <a href="#contatti" onClick={() => setOpen(false)} className="mt-2 inline-flex justify-center bg-[#2E3131] text-[#F5F6F2] rounded-full py-3 text-sm">
                Valuta la tua casa
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};

export default Navigation;
